import React from 'react';

export default function GentlemenBowtieSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Left wing of bowtie */}
      <path d="M4 14 L18 19 L18 21 L4 26 Z" fill="#8B0000" />
      {/* Right wing */}
      <path d="M36 14 L22 19 L22 21 L36 26 Z" fill="#8B0000" />
      {/* Left wing fold shading */}
      <path d="M4 14 L4 26 L8 23 L8 17 Z" fill="#5D0000" />
      <path d="M36 14 L36 26 L32 23 L32 17 Z" fill="#5D0000" />
      {/* Center knot */}
      <rect x="17" y="16" width="6" height="8" rx="1" fill="#5D0000" />
      {/* Knot highlight */}
      <rect x="18" y="17" width="1" height="6" fill="#A52A2A" opacity="0.8" />
      {/* Tiny stitch detail */}
      <circle cx="20" cy="20" r="0.6" fill="#3D0000" />
    </svg>
  );
}
